// extracted by mini-css-extract-plugin
export default {"navigation-tabs":"navigation-tabs_navigation-tabs__iFXZw"};